// l10n status: partial
console.debug("LOADING Search.jsx")
import { CreateComponent } from "components/utils/CreateComponent"
import React, { createRef, useEffect, useLayoutEffect, useRef, useState } from "react"
import searchIcon from "img/icons/search.svg"
import CloseIcon from '@mui/icons-material/Close'
import { Button, Divider, ListItemSecondaryAction } from "@mui/material"
import { observer } from "mobx-react"
import { runInAction } from "mobx"
import { rootStore } from "store/RootStore"
import InputBase from '@mui/material/InputBase'
import LinearProgress from "@mui/material/LinearProgress"
import { List } from '@mui/material'
import { ListItem } from '@mui/material'
import { IconButton } from '@mui/material'
import { ListItemText } from '@mui/material'
import goBack from "img/icons/search/arrow_back_ios_white_36dp.svg"
import goForward from "img/icons/search/arrow_forward_ios_white_36dp.svg"
import { ROUTE_NAMES } from "site-ql/RouteConst"
import { useNavigateRouteAdd } from "components/utils/RouteUtils"

import LiveIndicator from "img/icons/liveInSearch.svg"
import Play from "img/icons/playInSearch.svg"
import PersonIcon from "img/person.svg"

import genreLogo from "img/icons/genre.svg"
import serieLogo from "img/icons/series.svg"

import { CALLING_CONTEXT_TYPE } from "store/page/OverlayEventDetails"
import { FilterEventTypeBar } from "scenes/Search/components/FilterTypeEventBar"

import './SearchStyle.css'
import { l10n } from "store/lang/L10n"
import { debounce } from "lodash"
// MTVW-937: use emptyPng for non existent posterUrl
// import fallbackImageCategory to avoid vite runtime error in production build
// (Cannot access 'H6' before initialization)
import { fallbackImageCategory } from "store/util/fallbackImage"
import { emptyPng } from "store/util/fallbackImage"
import tvAllPng from "img/fallback/tv_category_all.png"
import { moment } from "store/util/moment"
import { getUpcomingLabelName } from "utils/Utils"
import { CircularProgress } from "@mui/material"
import { dateAndTime, eventType, endTs, startTs, durationInPercent } from "utils/EventHelpers"
import { languageName, countryName} from "utils/IntlManager"
import { appFeatures } from "AppFeatures"
import adultContent from "img/fallback/adult_content.png"
import PinLock from "img/icons/pin_protected.svg"
import {useAdultPinGuard} from "hooks/useAdultPinGuard"

import './SearchStyle.css'
import "scenes/components/EpisodeAndRelatedTile.css"
import { analyticsEvent, analyticsScreen, analyticsMeta, analyticsProgramDetailsSource } from "store/qlapi/LogService"

let oldFilters = []
//const tvAllPng = fallbackImageCategory("all")
//console.debug("fallbackImageCategory", fallbackImageCategory("all"), tvAllPng)

const FilterButtons = ({ page }) => {
	// const [size, setSize] = useState()
	const [scrollArrow, setScrollArrows] = useState({
		leftArrow: false,
		rightArrow: false,
	})
	const [filterIsOverflowing, setFilterIsOverflowing] = useState(false)

	const filters = useRef([])

	const refSearchFilter = useRef()

	// this condition prevents flickering when a new search is loaded and for a while page.overview is null. 
	if (!page.overview) {
		filters.current = oldFilters
	}
	else {
		oldFilters = filters.current
	}

	const handleResize = () => {
		const overFlow = refSearchFilter?.current?.clientWidth < refSearchFilter?.current?.scrollWidth
		setFilterIsOverflowing(overFlow)
		// MTVW-547: update arrow states
		setScrollArrows({
			leftArrow: overFlow ? refSearchFilter?.current?.scrollLeft > 0 : false,
			rightArrow: overFlow ? refSearchFilter?.current?.scrollLeft === 0 : false
		})
	}

	useEffect(() => {
		if (refSearchFilter?.current) {
			refSearchFilter.current.scrollLeft = 0
			setScrollArrows({
				leftArrow: filterIsOverflowing ? refSearchFilter?.current?.scrollLeft > 0 : false,
				rightArrow: filterIsOverflowing ? refSearchFilter?.current?.scrollLeft === 0 : false
			})
		}
	}, [filterIsOverflowing])

	useEffect(() => {
		setFilterIsOverflowing(refSearchFilter?.current?.clientWidth < refSearchFilter?.current?.scrollWidth)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [refSearchFilter?.current?.scrollWidth])

	useEffect(() => {
		window.addEventListener("resize", handleResize)
		return (() => {
			window.removeEventListener("resize", handleResize) // when unload
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])


	const pills = []
	for (const item in page.overview) {
		// MTVW-1011: determine active pills
		//console.debug("check", item, page.overview[item])
		//if (page.overview[item]?.length > 0 || page.filterLabel[item] === page.filterLabel[page.CATEGORY_TOP] || item === page.categorySelected) {
		if (page.overview?.[item]?.showFilterPill) {
			//console.debug("push", item)
			pills.push(item)
		}
	}
	filters.current = pills
	//console.debug("filters=", filters.current, page.overview)

	return (
		<div className='SearchFilterBarContainer' >
			<img className={`SearchFilterBarArrow ${!scrollArrow.leftArrow ? 'SearchFilterBarArrowDisabled' : ''}`} src={goBack} alt=" icon"
				onClick={(e) => {
					// MTVW-547:
					//refSearchFilter.current.scrollLeft = 0
					let scrollPos = refSearchFilter?.current?.scrollLeft - refSearchFilter?.current?.clientWidth / 2
					if (scrollPos < 0) scrollPos = 0
					refSearchFilter.current.scrollLeft = scrollPos
					setScrollArrows({ leftArrow: false, rightArrow: true })
				}}
			></img>
			<div className="SearchFilterBar" ref={refSearchFilter}
				onScroll={() => {
					const maxScrollLeft = Math.floor(refSearchFilter?.current?.scrollWidth - refSearchFilter?.current?.clientWidth) - 2
					//console.debug("scroll refSearchFilter.current.scrollLeft =%s --- max=%s", refSearchFilter.current?.scrollLeft, maxScrollLeft)
					if (refSearchFilter?.current?.scrollLeft === 0) {
						setScrollArrows({ leftArrow: false, rightArrow: true })
					} else if (refSearchFilter?.current?.scrollLeft > maxScrollLeft) {
						setScrollArrows({ leftArrow: true, rightArrow: false })
					} else {
						setScrollArrows({ leftArrow: true, rightArrow: true })
					}
				}}
			>
				{filters.current.map((item, index) => {
					return (
						<FilterButton key={item + index} text={page.filterLabel[item]} originalBackEndValue={item} page={page} isSelected={item === page.categorySelected} />
					)
				})}

			</div>
			<img className={`SearchFilterBarArrow ${!scrollArrow.rightArrow ? 'SearchFilterBarArrowDisabled' : ''}`} src={goForward} alt=" icon"
				onClick={(e) => {
					// MTVW-547:
					//refSearchFilter.current.scrollLeft = refSearchFilter.current.scrollWidth
					let scrollPos = refSearchFilter?.current?.scrollLeft + refSearchFilter?.current?.clientWidth / 2
					if (scrollPos > refSearchFilter?.current?.scrollWidth) scrollPos = refSearchFilter?.current?.scrollWidth
					refSearchFilter.current.scrollLeft = scrollPos
					setScrollArrows({ leftArrow: true, rightArrow: false })
				}}
			></img>
		</div>
	)
}

const FilterButton = ({ text, originalBackEndValue, page, isSelected = false }) => {
	const rootSearchFilterButton = isSelected ? 'searchFilterButtons searchFilterButtonSelected' : 'searchFilterButtons'
	return (
		<Button variant="outlined" style={{ color: "#FFF" }}
			onClick={() => {
				//console.debug("click", page.searchInProgress, originalBackEndValue, analyticsEvent[originalBackEndValue].tapEvent, Object.keys(page.overview))
				page.setCategorySelected(originalBackEndValue)
				// MTVW-1045
				rootStore.logService.analyticsTapEvent(analyticsEvent[originalBackEndValue].tapEvent,  { [analyticsMeta.searchItem]: page.searchInProgress })
			}}
			classes={{ root: `${rootSearchFilterButton}` }}
		>{text}</Button>
	)
}

const SearchBar = React.forwardRef((props, ref) => {
	useEffect(() => {
		/* eslint-disable no-unused-expressions */
		ref?.current?.firstElementChild.focus()
		ref?.current?.focus()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const [top, setTop] = useState(null)
	useEffect(() => {
		/* eslint-disable no-unused-expressions */
		if (props.page.overview?.top) setTop(props.page.overview?.top)
		//console.debug("props.page.overview", props.page.overview)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.page.overview?.top, props.page.overview?.recordings])

	return (
		<div className="searchBarTopContainer">
			<div className="searchBarContainer">
				<div className="searchBar">
					<div className="iconSearchTextField">
						{/* MTVW-619: style added */}
						<img src={searchIcon} alt="search" style={{ height: 25, width: 25, marginTop: 9 }} />
					</div>
					<InputBase
						id="search_input_box"
						className="SearchBarInput"
						ref={ref}
						// eslint-disable-next-line jsx-a11y/no-autofocus
						autoFocus={true}
						placeholder={l10n.featureSearchTitle}
						data_test="search_input_box"
						onChange={(e) => { props.handleNewSearch(e.target.value) }}
					/>
					<div className="iconDeleteTextField"
						onClick={(e) => {
							e.stopPropagation()
							props.resetSearchTxt()
						}}>
						{props.showResetIcon && <CloseIcon />}
					</div>
				</div>
			</div>
			<div className="searchAndFilterContainer" >
				{/* MTVW-645: no filter bar if no top results */}
				{/* MTVW-1011, MTVW-1016: commented && props.page.overview?.top?.length > 0 */}
				{props.page.categorySelected /*&& props.page.overview?.top?.length > 0*/ && <FilterButtons page={props.page} />}
			</div>
			{/* MTVW-624: added argument items */}
			{props.page.categorySelected === props.page.CATEGORY_MOVIES && <FilterEventTypeBar page={props.page} items={props.page.overview?.movies} />}
		</div>
	)
})

const StartPage = observer(({ setSearch, searchBar, page }) => {
	const PopularSearch = ['Tagesschau', 'Meteo', 'The Big Bang Theory', 'Formula 1']
	const [recentSearches, setRecentSearches] = useState(rootStore.sso.browserStore.getRecentSearches())
	runInAction(() => {
		page.overview = {}
	})

	return (
		<div className="startPage" data_test="search_start_page">
			{recentSearches?.length > 0 && <div className="startPageSearchesTitles">{l10n.featureSearchRecentSearches}</div>}
			{recentSearches?.length === 0 ? <NotFound type={NOTFOUND_TYPE.NORECENTS} /> : <Divider key={'none'} />}
			<List>
				{recentSearches.map((item, index) => {
					return (<React.Fragment key={item}>
						<ListItem
							key={index + item}
							classes={{ gutters: "startPageListGutters" }}
							onClick={() => {
								searchBar.current.firstElementChild.value = item
								rootStore.sso.lastSearch = item
								setSearch(item)
							}}>
							<ListItemText
								classes={{ primary: "startPageSearchesText" }}
								primary={item}
							/>
							<ListItemSecondaryAction onClick={() => {
								rootStore.sso.browserStore.setRecentSearches(recentSearches.filter(value => value !== item))
								// force page update
								setRecentSearches(rootStore.sso.browserStore.getRecentSearches())
							}}
							>
								<IconButton edge="end" aria-label="delete">
									<CloseIcon classes={{ root: "searchCloseRecentSearchIcon" }} />
								</IconButton>
							</ListItemSecondaryAction>
						</ListItem>
						<Divider key={index} />
					</React.Fragment>
					)
				})}
			</List>
			{/* MTVW-624: popular searches currently commented since they are constant
			<div className="startPageSearchesTitles">{l10n.featureSearchPopularSearches}</div>
			<Divider />
			<List>
				{PopularSearch.map((item, index) => {
					return (<React.Fragment key={index}>
						<ListItem
							key={index + item}
							classes={{ gutters: "startPageListGutters" }}
							onClick={() => {
								searchBar.current.firstElementChild.value = item
								rootStore.sso.lastSearch = item
								setSearch(item)
							}}>
							<ListItemText
								classes={{ primary: "startPageSearchesText" }}
								primary={item}
							/>
						</ListItem>
						<Divider key={index} />
					</React.Fragment>
					)
				})}
			</List>
			*/}
		</div>
	)
})

export const NOTFOUND_TYPE = {
	NOTFOUND: 0,
	NOHINT: 1,
	NORECENTS: 2
}

export const NotFound = ({ type = NOTFOUND_TYPE.NOTFOUND }) => {
	//console.debug("type=", type)
	return (
		<div className="notFoundPage" data_test="search_not_found_page">
			<img className="notFoundIcon" src={searchIcon} alt="search not found" />
			{type !== NOTFOUND_TYPE.NORECENTS ?
				<div>
					<h2>{l10n.featureSearchNoResults}</h2>
					{type !== NOTFOUND_TYPE.NOHINT ? <p>{l10n.featureSearchNoResultsHint}</p> : <></>}
				</div>
				: <></>
			}
		</div>
	)
}

const Channels = ({ item, withName, page }) => {
	const navigateRouteAdd = useNavigateRouteAdd()
	if (!withName) {
		return (
			<div className="ChannelContainer" onClick={() => {
				rootStore.page.LiveTv.handlePlayChannelLive(item.id)
				navigateRouteAdd(ROUTE_NAMES.LiveTv)
				page.addToRecentSearch(item.name)
			}}>
				<img className="searchLogoChannel" src={item.logoUri} alt={`channel ${item.name} logo`}></img>
			</div>
		)
	}
	else return (
		<div className="namedChannelContainer" onClick={() => {
			rootStore.page.LiveTv.handlePlayChannelLive(item.id)
			navigateRouteAdd(ROUTE_NAMES.LiveTv)
			page.addToRecentSearch(item.name)
		}}>
			<div className="namedChannelLogo">
				<img className="namedSearchLogoChannel" src={item.logoUri} alt={`channel ${item.name} logo`}></img>
			</div>
			<div className="searchEventActorsAndGenresInfo">
				<div className="searchEventActorsAndGenresText">{item.name}</div>
			</div>
		</div>
	)
}

const ActorsAndGenres = ({ type, item, page }) => {
	let _infoText = ""
	let _cardIcon = null

	if (type === page.TYPE_CREDIT) {
		_infoText = item.name
		// MTVW-1076: Add actor pictures to actor search results
		//_cardIcon = <img className='searchActorIcon' /*src={PersonIcon}*/ src={item.imageUrl} alt=" icon"></img>
		_cardIcon = (
			<div className="searchActorContainer">
				{/*<img className='searchActorIcon' src={item.imageUrl} alt=" icon"></img>*/}
				<div className="searchActorEllipse1" />
				{item.imageUrl ?
					<img loading="lazy" className="searchActorIcon" src={item.imageUrl} alt=" icon" />
					:
					<img loading="lazy" className="searchActorIconDefault" src={PersonIcon} alt=" icon" />
				}
				<div className="searchActorEllipse2" />
			</div>
		)
	} else if (type === page.TYPE_GENRE) {
		_infoText = item
		_cardIcon = <img className='searchGenreIcon' src={genreLogo} alt=" icon"></img>
	} else {
		return null
	}
	return (
		<div className="searchEventActorsAndGenresContainer"
			data_test={`search_actors_genres_container ${type === page.TYPE_CREDIT ? page.CATEGORY_ACTORS : page.CATEGORY_GENRES}`}
			onClick={() => {
				if (type === page.TYPE_CREDIT) {
					//console.debug("click", page.TYPE_CREDIT, analyticsScreen.personRelatedPrograms, analyticsEvent[page.categorySelected]?.tapEvent)
					// MTVW-1045: analytics
					rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: analyticsScreen.personRelatedPrograms, source: analyticsEvent[page.categorySelected]?.tapEvent }).then((res) => {
						rootStore.page.OverlayEventDetails.setActorName(_infoText).setComponentType(page.CATEGORY_ACTORS).setShow(true, CALLING_CONTEXT_TYPE.Search)
					})
				} else if (type === page.TYPE_GENRE) {
					//console.debug("click", page.TYPE_GENRE, analyticsScreen.genreRelatedPrograms, analyticsEvent[page.categorySelected]?.tapEvent)
					// MTVW-1045: analytics
					rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: analyticsScreen.genreRelatedPrograms, source: analyticsEvent[page.categorySelected]?.tapEvent }).then((res) => {
						rootStore.page.OverlayEventDetails.setGenre(_infoText).setComponentType(page.CATEGORY_GENRES).setShow(true, CALLING_CONTEXT_TYPE.Search)
					})
				}
				page.addToRecentSearch(_infoText)
			}}
		>
			<div className="searchEventActorsAndGenresLogoContainer">
				{_cardIcon}
			</div>
			<div className="searchEventActorsAndGenresInfo">
				<div className="searchEventActorsAndGenresText">{_infoText}</div>
			</div>
		</div>
	)
}
const Programs = observer((props) => {
	// MTVW-1016: added recordingType
	const { item, recordingsType, page, typeCards } = props
	//console.debug("Programs search %o, type %o, page %o, typeCards %o", item, recordingsType, page, typeCards )

	// this will do a re-render after a interactionEvent that calls getBookmarksAsync via notifyStopped
	useEffect(() => {
		//console.debug("useEffect Programs", rootStore.page.CoCoBookmarks.refreshCount, item)
	}, [rootStore.page.CoCoBookmarks.refreshCount])

	const _EVENT_DATA = {
		logoImgSrc: null,
		channelName: null,
		channelId: null,
		eventTitle: null,
		genres: null,
		seasonInfo: null,
		programDate: null,
		liveIcon: null,
		progressBar: null,
		playButton: null,
		seriesMobileIcon: null,
		type: null,
		// CoCo TODO: Handling of CoCo events, not yet used
		//event: null,
		idEvent: null,
		idSerie: null,
	}

	const backGroundImgStyle = { ...page.backGroundImgStyle }

	const cocoBookmarks = rootStore.page.CoCoBookmarks
	const [bookmarkInfo, setBookmarkInfo] = useState(null)

	// MTVW-1116: Flag to determine if we should actually show anything
   let isInvalid = false

	const loadDataForMoviesEvent = (isEventRecording = false) => {
		//console.debug("loadDataForMoviesEvent", item?.event)
		cocoBookmarks.getBookmarkAsync(null, false, item?.event?.id).then((bm) => {
			if (bm && !isLiveEvent && bm.position !== bookmarkInfo?.position) {
				// MTVW-899: don't hide anymore
				//const bmProgress = bm.hidden ? null : 100 * (bm.position - startTs(item?.event)) / (endTs(item?.event) - startTs(item?.event))
				const bmProgress = 100 * (bm.position - startTs(item?.event)) / (endTs(item?.event) - startTs(item?.event))
				setBookmarkInfo({ progress: bmProgress, id: item?.event?.id, position: bm.position })
			}
			else if (bookmarkInfo && !bm) setBookmarkInfo(null)
		})
		_EVENT_DATA.type = page.TYPE_EVENT
		// CoCo TODO: Handling of CoCo events, not yet used
		//_EVENT_DATA.event = item
		//backGroundImgStyle.backgroundImage = `${page.gradientImg},url(${item?.content?.posterUrl ?? tvAllPng}?mode=box&w=480&h=270`
		const backgroundImage = rootStore.channelsService?.isChannelPinProtected(item?.event?.channelId) ?
			adultContent : item?.content?.posterUrl ?? tvAllPngPng
		//console.debug("backgroundImage", "loadDataForMoviesEvent", item?.event?.channelId, backgroundImage)
		backGroundImgStyle.backgroundImage = `${page.gradientImg},url(${backgroundImage}?mode=box&w=480&h=270`
		const isLiveEvent = (eventType(item?.event) === 'c') ? true : false
		const isPastEvent = (eventType(item?.event) === 'p') ? true : false
		_EVENT_DATA.idEvent = item?.event?.id
		_EVENT_DATA.logoImgSrc = page.getChannelLogo(item?.event?.channelId)
		_EVENT_DATA.channelId = item?.event?.channelId
		_EVENT_DATA.channelName = <div className="searchChannelName" data_test="search_channel_name">{page.getChannelName(item?.event?.channelId)}</div>
		_EVENT_DATA.eventTitle = item?.content?.title
		// MTVW-1011: CoCo does no provide season and episode numbar for searched recording events
		//_EVENT_DATA.genres = isEventRecording && item?.content?.episodeName? item?.content?.episodeName : item?.content?.genres?.join?.(' \u25CF ')
		// MTVW-1133: EpisodeName -> episodeName
		_EVENT_DATA.genres = isEventRecording && item?.content?.episodeName? item?.content?.episodeName : item?.content?.genres?.join?.(' \u25CF ')
		/*
		_EVENT_DATA.genres = isEventRecording && item?.content?.episodeName? item?.content?.episodeName : item?.content?.genres?.join?.(' \u25CF ')
		_EVENT_DATA.seasonInfo = l10n.featureSearchSeriesInfo.format(item?.seasonCount, item?.episodeCount, item?.language? languageName(item?.language) : "")
		if (!item?.language) {
			//console.debug("seasonInfo", _EVENT_DATA.seasonInfo, _EVENT_DATA.seasonInfo.lastIndexOf(" • "), _EVENT_DATA.seasonInfo.length)
			_EVENT_DATA.seasonInfo = _EVENT_DATA.seasonInfo.substring(0, _EVENT_DATA.seasonInfo.lastIndexOf(" • "))
		}
		//_EVENT_DATA.eventTitle =
		*/
		_EVENT_DATA.programDate = dateAndTime(item?.event)
		const recordingsMarker = () => {
			//console.debug("recordingsMarker=", rootStore.page.Recordings.Manager.getMarker(item?.event?.id ?? item?.data?.event?.id))
			return rootStore.page.Recordings.Manager.getMarker(item?.event?.id ?? item?.data?.event?.id)
		}
		// MTVW-976: replaced
		//_EVENT_DATA.liveIcon = isLiveEvent ? <img src={LiveIndicator} className="searchLiveIndicator" data_test="search_event_live_icon" alt="" /> : null
		const isRecording = () => {
			//console.debug("getMarker=", rootStore.page.Recordings.Manager.getMarker(item?.event?.id ?? item?.data?.event?.id))
			//return rootStore.page.Recordings.Manager.getMarker(item?.event?.id ?? item?.data?.event?.id)
			//console.debug("isRecording=", item, item?.recordingStates?.[0].profileId, item.data?.recordingStates?.[0].profileId, item.event, item?.recordingStates?.[0].eventId, item.event.id)
			return (item?.recordingStates?.[0] ?? item.data?.recordingStates?.[0]) || recordingsMarker()
		}
		const profileName = () => {
			//const marker = rootStore.page.Recordings.Manager.getMarker(item?.event?.id ?? item?.data?.event?.id)
			//return marker?.ProfileId !== rootStore?.sso?.profile?.id ? rootStore.sso.getProfile(marker?.ProfileId)?.name : null
			//const recProfileId = item?.recordingStates?.[0].profileId ? item?.recordingStates?.[0].profileId : item.data?.recordingStates?.[0].profileId ?? null
			//console.debug("profileName=", item, recordingsMarker())
			let recProfileId = item?.recordingStates?.[0].profileId ? item?.recordingStates?.[0].profileId : null
			if (!recProfileId) recProfileId = recordingsMarker()?.ProfileId
			return recProfileId !== rootStore?.sso?.profile?.id ? rootStore.sso.getProfile(recProfileId)?.name : null
		}
		_EVENT_DATA.recording = isRecording() ?
			<div style={{ display: "flex", position: "absolute", left: 3, bottom: 28 }} className="recordingIndicator">
				<div className="recordingStatusIndicator">
					<div className="recordingStatusShape" />
				</div>
				{profileName() &&
					<div style={{ maxWidth: 190, fontSize: 16, fontFamily: "EuropaRegular", color: "rgba(255,255,255,0.8)" }} className="recordingProfileName">{profileName()}</div>
				}
			</div>
			: null
		_EVENT_DATA.progressBar = isLiveEvent ? <LinearProgress
																classes={{ root: "searchMuiLinearProgress" }}
																variant="determinate"
																value={Math.max(0, Math.min(100, Math.round(durationInPercent(item.event))))}
																data-test="search_event_progressbar"
															 /> : null
		/* MTVW-976: replaced with _EVENT_DATA.liveIcon
		_EVENT_DATA.playButton = (isLiveEvent || isPastEvent) && page.isReplayAllowed(item?.event) ? <div style={{ position: 'relative' }}>
			<img className="searchPlayIcon" src={Play} alt="play" data_test="search_event_play_icon" style={{ bottom: isLiveEvent || bookmarkInfo?.id === item?.event?.id ? "10px" : "-1px" }}
				onClick={(e) => {
					// MTVW-624: autoplay support
					e.stopPropagation()
					// setShow first so that derived 'origin' is correct
					rootStore.page.OverlayEventDetails.setShow(true, CALLING_CONTEXT_TYPE.Search)
					rootStore.page.OverlayEventDetails.setEpgEventById(_EVENT_DATA.idEvent, true, { [analyticsMeta.screen]: analyticsScreen.programDetails, source: analyticsProgramDetailsSource.search }).then((res) => {
						rootStore.page.OverlayEventDetails.setComponentType('event')
					})
				}}></img>
		</div> : null
		*/
		_EVENT_DATA.liveIcon = isLiveEvent ? <div style={{ right: 1, position: 'relative' }}>
			<div className="searchLiveIcon">
				<div className="liveFrame">
					<div className="liveContainer">
						<div className="liveEllipse" />
					</div>
					<div className="liveLabel">{l10n.featureSearchLiveResult}</div>
				</div>
			</div>
		</div> : null
		_EVENT_DATA.hasUpcomingLabel = () => {
			let start = null
			if (item?.event) start = startTs(item?.event)
			else start = startTs(item?.data?.event)
			if (!start) debugger
			//console.debug("hasUpcomingLabel Search for movies", item)
			return getUpcomingLabelName(start)
		}
	}

	//console.debug("typeCards", typeCards, recordingsType, item)
	switch (typeCards) {
		case page.CATEGORY_TOP:
		case page.CATEGORY_SPORTS:
			{
				const content = item?.data?.content ?? item.content
				const event = item?.data?.event ?? item.event
				//console.debug("typeCards", typeCards, recordingsType, item, content, event)
				const channelId = item?.type === page.TYPE_EVENT ? item?.data?.event?.channelId : null
				const backgroundImage = rootStore.channelsService?.isChannelPinProtected(channelId) ?
					adultContent
					:
					item?.type === page.TYPE_EVENT ? item?.data?.content?.posterUrl ?? tvAllPng : item?.data?.posterUrl ?? tvAllPng
				//console.debug("backgroundImage", page.CATEGORY_TOP, item?.type, channelId, item)
				//backGroundImgStyle.backgroundImage = `${page.gradientImg},url(${item?.type === page.TYPE_EVENT ? item?.data?.content?.posterUrl ?? tvAllPng : item?.data?.posterUrl ?? tvAllPng}?mode=box&w=480&h=270)`
				backGroundImgStyle.backgroundImage = `${page.gradientImg},url(${backgroundImage}?mode=box&w=480&h=270)`
				_EVENT_DATA.type = item.type
				if (item.type === page.TYPE_EVENT || item.event) {
					const isLiveEvent = eventType(event) === 'c' ? true : false
					const isPastEvent = eventType(event) === 'p' ? true : false
					//console.debug("CATEGORY_SPORTS event", item)
					//console.debug("event= 1", item?.data?.event)
					cocoBookmarks.getBookmarkAsync(null, false, event?.id).then((bm) => {
						if (bm && !isLiveEvent && bm.position !== bookmarkInfo?.position) {
							// MTVW-899: don't hide anymore
							//const bmProgress = bm.hidden ? null : 100 * (bm.position - startTs(item?.data?.event)) / (endTs(item?.data?.event) - startTs(item?.data?.event))
							const bmProgress = 100 * (bm.position - startTs(event)) / (endTs(event) - startTs(event))
							//console.debug("bookmark updated event= 1", item?.data?.content.title, bm.position, bmProgress, item.data)
							setBookmarkInfo({ progress: bmProgress, id: event?.id, position: bm.position })
						}
						else if (bookmarkInfo && !bm) setBookmarkInfo(null)
					})
					_EVENT_DATA.idEvent = event?.id
					_EVENT_DATA.logoImgSrc = page.getChannelLogo(event?.channelId)
					_EVENT_DATA.channelId = event?.channelId
					_EVENT_DATA.channelName = <div className="searchChannelName" data_test="search_channel_name">{page.getChannelName(event?.channelId)}</div>
					_EVENT_DATA.eventTitle = content?.title
					_EVENT_DATA.genres = content?.genres.join(' \u25CF ')
					_EVENT_DATA.programDate = dateAndTime(event)
					// MTVW-976: replaced
					//_EVENT_DATA.liveIcon = isLiveEvent ? < img src={LiveIndicator} className="searchLiveIndicator" data_test="search_event_live_icon" alt="" /> : null
					const recordingsMarker = () => {
						//console.debug("recordingsMarker=", rootStore.page.Recordings.Manager.getMarker(item?.event?.id ?? item?.data?.event?.id))
						return rootStore.page.Recordings.Manager.getMarker(event?.id)
					}
					const isRecording = () => {
						//console.debug("isRecording=1", rootStore.page.Recordings.Manager.getMarker(event?.id))
						//return rootStore.page.Recordings.Manager.getMarker(event?.id)
						console.debug("isRecording sports", item?.recordingStates?.[0], item.data?.recordingStates?.[0])
						return (item?.recordingStates?.[0] ?? item.data?.recordingStates?.[0]) || recordingsMarker()
					}
					const profileName = () => {
						//const marker = rootStore.page.Recordings.Manager.getMarker(event?.id)
						//return marker?.ProfileId !== rootStore?.sso?.profile?.id ? rootStore.sso.getProfile(marker?.ProfileId)?.name : null
						let recProfileId = item?.recordingStates?.[0].profileId ? item?.recordingStates?.[0].profileId : null
						if (!recProfileId) recProfileId = recordingsMarker()?.ProfileId
						return recProfileId !== rootStore?.sso?.profile?.id ? rootStore.sso.getProfile(recProfileId)?.name : null
					}
					_EVENT_DATA.recording = isRecording() ?
						<div style={{ display: "flex", position: "absolute", left: 3, bottom: 28 }} className="recordingIndicator">
							<div className="recordingStatusIndicator">
								<div className="recordingStatusShape" />
							</div>
							{profileName() &&
								<div style={{ maxWidth: 190, fontSize: 16, fontFamily: "EuropaRegular", color: "rgba(255,255,255,0.8)" }} className="recordingProfileName">{profileName()}</div>
							}
						</div>
						: null
					_EVENT_DATA.progressBar = isLiveEvent ? <LinearProgress
																			classes={{ root: "searchMuiLinearProgress" }}
																			variant="determinate"
																			value={Math.max(0, Math.min(100, Math.round(durationInPercent(event))))}
																			data-test="search_event_progressbar"
																		 /> : null
					/* MTVW-976: replaced with _EVENT_DATA.liveIcon
					_EVENT_DATA.playButton = (isLiveEvent || isPastEvent) && page.isReplayAllowed(item?.data?.event) ? <div style={{ position: 'relative' }}>
						<img className="searchPlayIcon" src={Play} alt="play" data_test="search_event_play_icon" style={{ bottom: isLiveEvent || bookmarkInfo?.id === item?.data?.event?.id ? "10px" : "-1px" }}
							onClick={(e) => {
								// MTVW-624: autoplay support
								e.stopPropagation()
								// setShow first so that derived 'origin' is correct
								rootStore.page.OverlayEventDetails.setShow(true, CALLING_CONTEXT_TYPE.Search)
								rootStore.page.OverlayEventDetails.setEpgEventById(_EVENT_DATA.idEvent, true, { [analyticsMeta.screen]: analyticsScreen.programDetails, source: analyticsProgramDetailsSource.search }).then((res) => {
									rootStore.page.OverlayEventDetails.setComponentType('event')
								})
							}}></img>
					</div> : null
					*/
					_EVENT_DATA.liveIcon = isLiveEvent ? <div style={{ right: 1, position: 'relative' }}>
						<div className="searchLiveIcon">
							<div className="liveFrame">
								<div className="liveContainer">
									<div className="liveEllipse" />
								</div>
								<div className="liveLabel">{l10n.featureSearchLiveResult}</div>
							</div>
						</div>
					</div> : null
					_EVENT_DATA.hasUpcomingLabel = () => {
						let start = null
						if (event) start = startTs(event)
						if (!start) debugger
						//console.debug("hasUpcomingLabel TOP, SPORTS", item)
						return getUpcomingLabelName(start)
					}
				} else if (item.type === page.TYPE_SERIE) {
					_EVENT_DATA.idSerie = item?.data?.id
					_EVENT_DATA.logoImgSrc = serieLogo
					_EVENT_DATA.channelId = item?.data?.channels?.[0]
					_EVENT_DATA.eventTitle = item?.data?.title
					//_EVENT_DATA.seasonInfo = `${item?.data?.seasonCount} ${item?.data?.seasonCount > 1 ? 'Staffeln' : 'Staffel'} ${'\u25CF'} ${item?.data?.episodeCount}  Episodes ${'\u25CF'} ${item?.data?.language} `
					_EVENT_DATA.seasonInfo = l10n.featureSearchSeriesInfo.format(item?.data?.seasonCount, item?.data?.episodeCount, languageName(item?.data?.language))
					if (!item?.data?.language) {
						//console.debug("seasonInfo", _EVENT_DATA.seasonInfo, _EVENT_DATA.seasonInfo.lastIndexOf(" • "), _EVENT_DATA.seasonInfo.length)
						_EVENT_DATA.seasonInfo = _EVENT_DATA.seasonInfo.substring(0, _EVENT_DATA.seasonInfo.lastIndexOf(" • "))
					}
					_EVENT_DATA.seriesMobileIcon = <div style={{ position: 'relative' }}>
						<img className="searchSeriesMobileIcon" src={serieLogo} alt="series" data_test="search_event_series_icon"></img>
					</div>
				}
			}
			break
		case page.CATEGORY_SERIES:
			//console.debug("CATEGORY_SERIES", item)
			_EVENT_DATA.type = typeCards
			backGroundImgStyle.backgroundImage = `${page.gradientImg},url(${item?.posterUrl ?? tvAllPng}?mode=box&w=480&h=270)`
			console.debug("backgroundImage", page.CATEGORY_SERIES, item)
			_EVENT_DATA.logoImgSrc = serieLogo
			_EVENT_DATA.eventTitle = item?.title
			_EVENT_DATA.idSerie = item?.id
			//_EVENT_DATA.seasonInfo = `${item?.seasonCount} ${item?.seasonCount > 1 ? 'Staffeln' : 'Staffel'} ${'\u25CF'} ${item?.episodeCount} Episodes  ${'\u25CF'} ${item?.language} `

			_EVENT_DATA.seasonInfo = l10n.featureSearchSeriesInfo.format(item?.seasonCount, item?.episodeCount, languageName(item?.language))
			if (!item?.language) {
				//console.debug("seasonInfo", _EVENT_DATA.seasonInfo, _EVENT_DATA.seasonInfo.lastIndexOf(" • "), _EVENT_DATA.seasonInfo.length)
				_EVENT_DATA.seasonInfo = _EVENT_DATA.seasonInfo.substring(0, _EVENT_DATA.seasonInfo.lastIndexOf(" • "))
			}
			_EVENT_DATA.seriesMobileIcon = <div style={{ position: 'relative' }}>
				<img className="searchSeriesMobileIcon" src={serieLogo} alt="series" data_test="search_event_series_icon"></img>
			</div>
			break
		case page.CATEGORY_RECORDINGS:
			/* MTVW-1016 item 9: not needed ?
			if (item.duplicate || item.ignore) {
				console.debug("CATEGORY_RECORDINGS_1", item)
		   }
			*/
			// MTVW-1016
			//console.debug("CATEGORY_RECORDINGS=", recordingsType, item.channelName, item.event.start, item.recordingStates.length, item.recordingStates[0].profileId, item)
			if (recordingsType === "event") loadDataForMoviesEvent(true)
			//else return null
			else {
				//console.debug("CATEGORY_RECORDINGS", item)
				_EVENT_DATA.type = typeCards
				backGroundImgStyle.backgroundImage = `${page.gradientImg},url(${item?.posterUrl ?? tvAllPng}?mode=box&w=480&h=270)`
				console.debug("backgroundImage", typeCards, item)
				_EVENT_DATA.logoImgSrc = serieLogo
				_EVENT_DATA.eventTitle = item?.title
				_EVENT_DATA.idSerie = item?.id
				// MTVW-1016: no language for recordings serie
				_EVENT_DATA.seasonInfo = l10n.featureSearchSeriesInfo.format(item?.seasonCount, item?.episodeCount, item?.language? languageName(item?.language) : "")
				if (!item?.language) {
					//console.debug("seasonInfo", _EVENT_DATA.seasonInfo, _EVENT_DATA.seasonInfo.lastIndexOf(" • "), _EVENT_DATA.seasonInfo.length)
					_EVENT_DATA.seasonInfo = _EVENT_DATA.seasonInfo.substring(0, _EVENT_DATA.seasonInfo.lastIndexOf(" • "))
				}
				_EVENT_DATA.seriesMobileIcon = <div style={{ position: 'relative' }}>
					<img className="searchSeriesMobileIcon" src={serieLogo} alt="series" data_test="search_event_series_icon"></img>
				</div>
			}
			break
		case page.CATEGORY_MOVIES:
			// MTVW-1016: FILTER_EVENT_RECORDINGS
			if (page.filterEventType === page.FILTER_EVENT_RECORDINGS) {
				loadDataForMoviesEvent()
			}
			else if (page.filterEventType === page.FILTER_EVENT_ALL) {
				loadDataForMoviesEvent()
			} else if (page.filterEventType === page.FILTER_EVENT_LIVE_REPLAY) {
				if ((eventType(item?.event) === 'p') || (eventType(item?.event) === 'c')) {
					loadDataForMoviesEvent()
				} else {
					// MTVW-1116
					//return null
					isInvalid = true
				}
			} else if (page.filterEventType === page.FILTER_EVENT_UPCOMING) {
				if ((eventType(item?.event) === 'n')) {
					loadDataForMoviesEvent()
				} else {
					//MTVW-1116
					//return null
					isInvalid = true
				}
			}
			break
		default:
			isInvalid = true
			break
	}

	// called when clicked
	const handleShowDetails = () => {
		if (_EVENT_DATA.type === page.CATEGORY_SERIES || recordingsType === "series") {
			//console.debug("analytics handleShowDetails, series", analyticsEvent[page.categorySelected]?.tapEvent, page.categorySelected)
			rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: analyticsScreen.seriesRelatedPrograms, source: analyticsEvent[page.categorySelected]?.tapEvent }).then((res) => {
				rootStore.page.OverlayEventDetails.setComponentType(page.CATEGORY_SERIES).setSeriesId(_EVENT_DATA.idSerie)
				.setSeriesTitle(_EVENT_DATA.eventTitle).setShow(true, CALLING_CONTEXT_TYPE.Search)
			})
		} else if (_EVENT_DATA.type === page.TYPE_EVENT || item.event) {
			//console.debug("analytics handleShowDetails, event", analyticsEvent[page.categorySelected]?.tapEvent, page.categorySelected)
			// setShow first so that derived 'origin' is correct
			rootStore.page.OverlayEventDetails.setShow(true, CALLING_CONTEXT_TYPE.Search)
			//console.debug("handleShowDetails", _EVENT_DATA.event)
			rootStore.page.OverlayEventDetails.setEpgEventById(_EVENT_DATA.idEvent, false, { [analyticsMeta.screen]: analyticsScreen.programDetails, source: analyticsEvent[page.categorySelected]?.tapEvent }).then((res) => {
			// CoCo TODO: Handling of CoCo events, not yet used
			//rootStore.page.OverlayEventDetails.setEpgEvent(_EVENT_DATA.event, false, { [analyticsMeta.screen]: analyticsScreen.programDetails, source: analyticsProgramDetailsSource.search }).then((res) => {
				rootStore.page.OverlayEventDetails.setComponentType('event')
			})
		}
		page.addToRecentSearch(_EVENT_DATA.eventTitle)
	}

	// MTVW-1094: PlayerCover for protected adult content
	const { handleProtectedClick, PinGuardElement } = useAdultPinGuard(() => {
		handleShowDetails()
	})

	// MTVW-1116: -- THE ONLY NULL CHECK ALLOWED --
   if (isInvalid) return null

	return (
		<>
		{PinGuardElement}
		<div className="eventContainer"
			data_test={`search_event ${_EVENT_DATA.type}`}
			onClick={(e) => {
				//console.debug("Programs")
				e.stopPropagation()
				//handleShowDetails()
				handleProtectedClick(page.getChannel(_EVENT_DATA.channelId))
			}}
		>
			<div className="searchEventLogoChannel">
				<img className={_EVENT_DATA.logoImgSrc === serieLogo ? "searchLogo" : "searchLogoChannel"} src={_EVENT_DATA.logoImgSrc} alt="channel logo"></img>

			</div>
			<div className="searchEventInfoContainer">
				<div className="searchEventInfo">
					<div className="searchEventInfoText" >
						{_EVENT_DATA.channelName}
						{rootStore.channelsService?.isChannelPinProtected(_EVENT_DATA.channelId) ?
							<div style={{display: "flex", flexDirection: "row", marginTop: 26}}>
								<img style={{ width: 20, height: 20, marginTop: 7, marginRight: 10 }} src={PinLock}></img>
								<div className="searchEventTitle" data_test="search_event_title">{l10n.featureContentPinProtected}</div>
							</div>
							:
							<>
								<div className="searchEventTitle" data_test="search_event_title">{_EVENT_DATA.eventTitle}</div>
								<div className="searchEventGenresInfo">{_EVENT_DATA.genres}</div>
							</>
						}
						{/* MTVW-1011: CoCo does not provide season and episode numbar for searched recording events
						<div className="searchEventTitle" data_test="search_event_title">
							{_EVENT_DATA.seasonInfo}
							{_EVENT_DATA.eventTitle}
						</div>
						*/}
					</div>
					<div className="searchEventInfoPoster">
						<div className="eventPosterSection" style={backGroundImgStyle} data_test="search_event_poster"></div>
					</div>
				</div>
				<div className="searchEventIconsAndBar">
					{!rootStore.channelsService?.isChannelPinProtected(_EVENT_DATA.channelId) &&
						<>
							{/* MTVW-976: replaced, see below
							{_EVENT_DATA.liveIcon}
							*/}
							{_EVENT_DATA.recording}
							<span data_test="search_event_info"> {_EVENT_DATA.seasonInfo ? _EVENT_DATA.seasonInfo : _EVENT_DATA.programDate}</span>
							{_EVENT_DATA.progressBar}
							{bookmarkInfo && (bookmarkInfo.id === item?.event?.id || bookmarkInfo.id === item?.data?.event?.id) &&
								<LinearProgress
									classes={{ root: "searchMuiLinearProgress" }}
									variant="determinate"
									value={Math.max(0, Math.min(100, Math.round(bookmarkInfo.progress)))}
									data-test="search_event_progressbar"
								/>
							}
							{/* MTVW-976: replaced with _EVENT_DATA.liveIcon
							{_EVENT_DATA.playButton}
							*/}
							{_EVENT_DATA.liveIcon}
							{_EVENT_DATA.seriesMobileIcon}
							{_EVENT_DATA.hasUpcomingLabel && _EVENT_DATA.hasUpcomingLabel() &&
								<div style={{ bottom: 10, right: 10 }} className="upcomingIndicator">
									<div className="upcomingLabel">{_EVENT_DATA.hasUpcomingLabel()}</div>
								</div>
							}
						</>
					}
				</div>
			</div>
		</div>
		</>
	)
})


const MainSearch = CreateComponent(null, false, true, props => {
	const { page } = props
	// eslint-disable-next-line no-unused-vars
	const [newCategory, setNewCategory] = useState()
	// MTVW-624: added useState below, otherwise movies might not correctly refreshed on tab change
	const [current, setCurrent] = useState(null)
	page.setRefresh(false)
	const peoplesInTop = useRef(0)
	const genresInTop = useRef(0)
	const channelsInTop = useRef(0)

	const _event = useRef()
	useLayoutEffect(() => {
		const mainSearch = () => {
			// MTVW-510 : TODO: Define if channels should also be displayed in top
			const TOP_CHANNELS = true
			let savedIndexPeoples = null
			let savedIndexGenres = null
			let savedIndexChannels = null
			let itemInTop = null

			peoplesInTop.current = 0
			genresInTop.current = 0
			channelsInTop.current = 0

			// MTVW-624: no background color for separators, open category when clicked
			const peoplesTitle = <div style={{ backgroundColor: "unset" }} className="eventContainerTitle" key="titleActors" id="testActors"
				onClick={(e) => {
					page.setCategorySelected(page.CATEGORY_ACTORS)
				}}>
				<h1>{l10n.featureSearchFilterCategoryActors} </h1></div>
			const genresTitle = <div style={{ backgroundColor: "unset" }} className="eventContainerTitle" key="titleGenres" id="testGenres"
				onClick={(e) => {
					page.setCategorySelected(page.CATEGORY_GENRES)
				}}>
				<h1>{l10n.featureSearchFilterCategoryGenres}</h1></div>
			const channelsTitle = <div style={{ backgroundColor: "unset" }} className="eventContainerTitle" key="titleChannels" id="testChannels"
				onClick={(e) => {
					page.setCategorySelected(page.CATEGORY_CHANNELS)
				}}>
				<h1>{l10n.featureSearchFilterCategoryChannels}</h1></div>

			if (!page.overview || !page.categorySelected) return
			const _categoryData = page.overview[page.categorySelected]
			//console.debug("categorySelected", page.categorySelected, _categoryData, page.overview)
			switch (page.categorySelected) {
				case page.CATEGORY_TOP:
					_event.current = _categoryData?.map((item, index) => {
						switch (item.type) {
							case page.TYPE_CREDIT:
								peoplesInTop.current++
								savedIndexPeoples = index
								if (savedIndexPeoples !== null && savedIndexPeoples !== index) peoplesInTop.current++
								itemInTop = <React.Fragment key={`actor-gen-frag-${index}`}>
									{peoplesInTop.current === 1 ? peoplesTitle : null}
									<ActorsAndGenres type={item.type}
										item={item.data} key={`${page.categorySelected}-${index}`} page={page} />
								</React.Fragment>
								break
							case page.TYPE_GENRE:
								genresInTop.current++
								savedIndexGenres = index
								if (savedIndexGenres !== null && savedIndexGenres !== index) genresInTop.current++
								itemInTop = <React.Fragment key={`actor-gen-frag-${index}`}>
									{genresInTop.current === 1 ? genresTitle : null}
									<ActorsAndGenres type={item.type}
										item={item.data.name} key={`${page.categorySelected}-${index}`} page={page} />
								</React.Fragment>
								break
							case page.TYPE_CHANNEL:
								if (TOP_CHANNELS) {
									channelsInTop.current++
									savedIndexChannels = index
									if (savedIndexChannels !== null && savedIndexChannels !== index) channelsInTop.current++
									itemInTop = <React.Fragment key={`frag-${index}`}>
										{channelsInTop.current === 1 ? channelsTitle : null}
										<Channels item={item.data} withName={true}
											key={`${page.categorySelected}-${index}`} page={page}
										/>
									</React.Fragment>
								}
								else itemInTop = null
								break
							default:
								itemInTop = <React.Fragment key={`prog-frag-${index}`}>
									<Programs item={item} page={page} typeCards={page.categorySelected}
										key={`${page.categorySelected}-${index}`} />
								</React.Fragment>
								break
						}
						return (<React.Fragment key={`mainTop-${index}`}>{itemInTop}</React.Fragment>)
					})
					break
				// MTVW-624: applyTabFilter for movies 
				case page.CATEGORY_MOVIES:
					_event.current = page.applyTabFilter(_categoryData, page.filterEventType)?.map((item, index) => {
						return (<Programs item={item} page={page} typeCards={page.categorySelected}
							key={`${page.categorySelected}-${index}`} />)
					})
					break	
				case page.CATEGORY_RECORDINGS:
					//console.debug("_categoryData", page.categorySelected, _categoryData)
					_event.current = _categoryData?.map((item, index) => {
					  //console.debug("CATEGORY_RECORDINGS=", item, index)
					  // MTVW-1016 item 9: Spinner instead of ingored placeholder recording 
						if (item?.data?.ignore) {
							//console.debug("CATEGORY_RECORDINGS_2", item?.data)
							return (
								<div style={{ display: "flex", justifyContent: "center", position: "relative", top: 50/*margin: "0 auto", height: 282, width: 282, position: "absolute"*/ }}>
									<CircularProgress size={70} />
								</div>
							)
						}
						else if (item?.data?.duplicate) {
							return null
						}
						return (<Programs item={item.data} recordingsType={item.type} page={page} typeCards={page.categorySelected}
							key={`${page.categorySelected}-${index}`} />)
					})
					break
				case page.CATEGORY_SERIES:
				case page.CATEGORY_SPORTS:
					_event.current = _categoryData?.map((item, index) => {
						//console.debug("CATEGORY_SPORTS", item)
						return (<Programs item={item} page={page} typeCards={page.categorySelected}
							key={`${page.categorySelected}-${index}`} />)
					})
					break
				case page.CATEGORY_ACTORS:
				case page.CATEGORY_GENRES:
					_event.current = _categoryData?.map((item, index) => {
						return (<ActorsAndGenres type={page.categorySelected === page.CATEGORY_ACTORS ? page.TYPE_CREDIT : page.TYPE_GENRE}
							item={item} key={`${page.categorySelected}-${index}`} page={page} />)
					})
					break
				case page.CATEGORY_CHANNELS:
					_event.current =
						<div className="searchChannelsMainContainer">
							{_categoryData?.map((item, index) => {
								return (<Channels item={item} withName={false}
									key={`${page.categorySelected}-${index}`} page={page}
								/>)
							})
							}
						</div>
					break
				default:
					_event.current = null
					break
			}
			setCurrent(_event.current)
		}
		// essential to have the result synchronized with the category
		// without the status change the visualization would be the previously selected category
		setNewCategory(page.categorySelected)
		mainSearch()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page.categorySelected, page.filterEventType, page.overview.recordings])

	return page.overview?.[page.categorySelected]?.length === 0 ? <NotFound /> :
		<div className="programsContainer" data_test={page.categorySelected}>
			{current}
		</div>
})

export const Search = CreateComponent(null, false, true, () => {
	const page = rootStore.page.Search
	const [txtToSearch, setTxtToSearch] = useState("")
	const ref = createRef()
	const refSearchMainContainer = useRef()

	/* MTVW-617: handled in page.addToRecentSearch 
	const MAX_RECENTS = 5
	const removeFromArray = (arr, what) => {
		//console.debug("arr %o, what %s", arr, what)
		for (let i = 0; i < arr?.length; i++) {
			if (arr[i].toLowerCase() === what.toLowerCase()) {
				//console.debug("remove %o", arr[i])
				arr.splice(i, 1)
				i--
			}
		}
	}
	*/

	const handleNewSearchImpl = (value) => {
		setTxtToSearch(value)
		// maintain recent searches in local storage
		// make a copy of the array, otherwise we going to modify the reference
		/* MTVW-617: handled in page.addToRecentSearch 
		let recent = [...rootStore.sso.browserStore.getRecentSearches()]
		if (!recent) recent = []
		const lValue = value
		removeFromArray(recent, rootStore.sso.lastSearch)
		if (lValue?.length > 1) removeFromArray(recent, lValue.substring(0, lValue.length - 1))
		// remove if already existing, could lead to MAX_RECENTS-1 entries
		removeFromArray(recent, lValue)
		// remove oldest at the bottom
		if (recent?.length >= MAX_RECENTS) removeFromArray(recent, recent[recent.length - 1])
		// insert at top
		if (lValue?.length > 0) recent.unshift(lValue)
		rootStore.sso.browserStore.setRecentSearches(recent)
		*/

		// MTVW-185: save last search
		//rootStore.sso.lastSearch = value
	}

	// mitigate flickering updates
	const handleNewSearch = debounce(handleNewSearchImpl, 500)

	const resetSearchTxt = () => {
		setTxtToSearch("")
		// MTVW-185
		rootStore.sso.lastSearch = ""
		if (ref.current) {
			ref.current.firstElementChild.value = ""
		}
		// MTVW-624: combined activityStack for related content and search
		rootStore.page.OverlayEventDetails.resetActivity()
	}

	// change the value in search
	useEffect(() => {
		// MTVW-185: restore the value also on page reload
		// MTVW-511: not need restore the value also on page reload anymore
		// const text = rootStore.sso.lastSearch
		// if (ref.current) {
		// 	ref.current.firstElementChild.value = text
		// }
		// if (page.repoReady && text !== "") {
		// 	setTxtToSearch(text)
		// }
		if (txtToSearch !== "") {
			//page.search(txtToSearch)
			// searchOverview is currently called from page.search, accessible from page.overview
			// lite without recordings
			page.searchOverview(txtToSearch, appFeatures.showAdultContent, true).then((res) => {
				// now full with recordings
				page.searchOverview(txtToSearch, appFeatures.showAdultContent, false)
			})
			//page.getSeries("crid:~~2F~~2Fmedia-press.tv~~2Fbase~~2Fde~~2F3169734")
			//page.getSeries("crid:~~2F~~2Fmedia-press.tv~~2Fseason~~2Fde~~2F1589422")
			//page.searchActor("Neil Flynn")
			//page.searchGenre("Spielfilm")
			//page.searchActorInGenre("Neil Flynn", "Spielfilm")
			//page.searchActorInGenre("Roger Moore", "Spielfilm")
			//page.searchGenreInGenre("Spielfilm", "Thriller")
			//page.search("James Bond", "", "Pierce")
			/* UNUSED
			//page.searchMovies("James Bond", "Thriller", "Sean")
			//page.searchSeries("Big Bang", "Komödie", "Johnny")
			//page.searchEpisodes("Big Bang", "Komödie", "Johnny")
			//page.searchEpisodes("Big Bang")
			*/
		}
		else page.clearSearch()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [txtToSearch, page.repoReady])

	useEffect(
		...page.getMountBody(
			() => {
				// MTVW-955
				rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: analyticsScreen.search })
			},
			() => {
				page.clearSearch()
			}
		))

	useEffect(() => {
		if (txtToSearch !== "") {
			if (page.categorySelected === null) page.setCategorySelected(page.CATEGORY_TOP)
			// mainSearch()
		} else {
			page.setCategorySelected(null)
			page.setGenresSelected(page.ALL_GENRES_SELECTED)
			page.setSeasonSelected(page.ALL_SEASON_SELECTED)
			page.setScrollposSelected(null)
		}
		refSearchMainContainer?.current?.scrollTo(0, 0)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page.categorySelected, txtToSearch, page.filterEventType])

	return (
		<div className="rootSearch" data_test="search_main_page">
			<div className="searchMainContainer" data_test="search_main_container" ref={refSearchMainContainer}>
				<SearchBar ref={ref} handleNewSearch={handleNewSearch} resetSearchTxt={resetSearchTxt} showResetIcon={txtToSearch !== ""} page={page} />
				{txtToSearch === "" ? <StartPage setSearch={setTxtToSearch} searchBar={ref} page={page} /> :
					page.isOverViewReady ? <MainSearch page={page} /> : null  /* add spinner?????*/}
			</div>
		</div>
	)
})
